import React, { useMemo } from "react";
import { PackPriceContext } from "./PackPriceContext";

interface PackPriceContextProviderProps {
  children: React.ReactNode;
}

export const PackPriceContextProvider: React.FC<PackPriceContextProviderProps> = ({ children }) => {
  const contextValue = useMemo(() => ({ hidePackPricing: true }), []);
  return <PackPriceContext.Provider value={contextValue}>{children}</PackPriceContext.Provider>;
};
